import React, { useEffect, useState } from 'react'
import useStore from '../../BusinessStore/Store'
import styles from './styles.module.css'

function Name () {
  const { name, setName, isQueryLoading } = useStore()
  const [inputValue, setInputValue] = useState(name)

  useEffect(() => {
    const timer = setTimeout(() => {
      setName(inputValue)
    }, 1000) // 1000ms = 1 second

    return () => clearTimeout(timer) // Clean up the timeout if the user types again before 1 second passes
  }, [inputValue, setName])

  const handleInputChange = e => {
    setInputValue(e.target.value)
  }

  useEffect(() => {
    setInputValue(name)
  }, [name])
  

  return (
    <div className={styles.nameContainerBusiness}>
      <h1 className={styles.nameBusinessLabel}>Name</h1>
      <input
        className={styles.nameInputBusiness}
        type='text'
        placeholder='e.g. Starbucks'
        value={inputValue}
        disabled={isQueryLoading}
        onChange={handleInputChange}
      />
    </div>
  )
}

export default Name

